/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len,react/jsx-tag-spacing */
import React from 'react';
import classNames from 'classnames';
import css from './Icon.module.scss';

interface Props {
  type: string;
  className?: string;
  width?: number;
  height?: number;
  color?: string;
  secondaryColor?: string;
  onClick?: (event: React.MouseEvent) => void;
}

const Icon = ({ type, className, width, height, color, secondaryColor, onClick, ...iconProps }: Props) => {
  let icon = null;
  const svgProps = {
    width,
    height,
    viewBox: `0 0 ${width || 38} ${height || 38}`,
    xmlns: 'http://www.w3.org/2000/svg',
  };

  switch (type) {
    case 'facebook':
      icon = (
        <svg id="face" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 27.999 27.667">
          <ellipse
            id="Ellipse_1_copy_2"
            data-name="Ellipse 1 copy 2"
            cx="13.999"
            cy="13.833"
            rx="13.999"
            ry="13.833"
            transform="translate(0)"
          />
          <path
            id="Icon_awesome-facebook-f"
            data-name="Icon awesome-facebook-f"
            d="M9.2,8.531l.421-2.745H6.988V4.005A1.372,1.372,0,0,1,8.535,2.522h1.2V.185A14.6,14.6,0,0,0,7.607,0,3.351,3.351,0,0,0,4.02,3.695V5.786H1.609V8.531H4.02v6.635H6.988V8.531Z"
            transform="translate(7.971 6)"
            fill="#f3c52a"
          />
        </svg>
      );
      break;
    case 'whatsapp':
      icon = (
        <svg id="wt" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 27.999 27.667">
          <ellipse
            id="Ellipse_1_copy_3"
            data-name="Ellipse 1 copy 3"
            cx="13.999"
            cy="13.833"
            rx="13.999"
            ry="13.833"
            transform="translate(0)"
          />
          <path
            id="Icon_simple-whatsapp"
            data-name="Icon simple-whatsapp"
            d="M11.935,9.809c-.205-.1-1.205-.591-1.391-.659s-.323-.1-.459.1-.526.658-.644.793S9.2,10.189,9,10.1A5.536,5.536,0,0,1,7.361,9.084,6.188,6.188,0,0,1,6.229,7.672c-.119-.2-.013-.317.089-.419s.205-.235.308-.357a1.729,1.729,0,0,0,.2-.338A.375.375,0,0,0,6.81,6.2c-.051-.1-.458-1.1-.629-1.5s-.332-.348-.458-.348-.253-.01-.389-.01a.769.769,0,0,0-.544.245A2.277,2.277,0,0,0,4.077,6.27a3.991,3.991,0,0,0,.831,2.1,9.1,9.1,0,0,0,3.478,3.059c.487.2.866.327,1.162.429a2.822,2.822,0,0,0,1.282.083,2.1,2.1,0,0,0,1.375-.973,1.688,1.688,0,0,0,.123-.972c-.05-.092-.184-.143-.389-.235M8.226,14.835H8.215a6.823,6.823,0,0,1-3.448-.941l-.246-.146-2.558.665.685-2.486-.163-.256A6.765,6.765,0,0,1,13.022,3.326a6.676,6.676,0,0,1,1.984,4.768A6.773,6.773,0,0,1,8.23,14.835M14,2.352A8.282,8.282,0,0,0,8.215,0,8.109,8.109,0,0,0,1.157,12.167L0,16.369l4.321-1.127a8.227,8.227,0,0,0,3.895.987h0a8.144,8.144,0,0,0,8.15-8.114,8.044,8.044,0,0,0-2.384-5.737"
            transform="translate(6.103 5.072)"
            fill="#f3c52a"
          />
        </svg>
      );
      break;

    case 'copy':
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 27.999 27.667">
          <g id="link" transform="translate(-399 -178)">
            <ellipse
              id="Ellipse_1_copy_2"
              data-name="Ellipse 1 copy 2"
              cx="13.999"
              cy="13.833"
              rx="13.999"
              ry="13.833"
              transform="translate(399 178)"
              fill="#070101"
            />
            <g id="Icon_feather-link" data-name="Icon feather-link" transform="translate(402.938 181.33)">
              <path
                id="Path_1"
                data-name="Path 1"
                d="M15,10.522a3.417,3.417,0,0,0,5.153.369l2.05-2.05a3.417,3.417,0,1,0-4.833-4.833L16.2,5.178"
                transform="translate(-6.536 0)"
                fill="none"
                stroke="#f3c52a"
              />
              <path
                id="Path_2"
                data-name="Path 2"
                d="M11.2,14.863a3.417,3.417,0,0,0-5.153-.369l-2.05,2.05a3.417,3.417,0,1,0,4.833,4.833l1.168-1.169"
                transform="translate(0 -5.707)"
                fill="none"
                stroke="#f3c52a"
              />
            </g>
          </g>
        </svg>
      );
      break;
    case 'accessibility':
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 27.999 27.667">
          <g id="ng" transform="translate(-360 -178)">
            <ellipse
              id="Ellipse_1_copy_2"
              data-name="Ellipse 1 copy 2"
              cx="13.999"
              cy="13.833"
              rx="13.999"
              ry="13.833"
              transform="translate(360 178)"
              fill="#f3c52a"
            />
            <path
              id="Icon_map-wheelchair"
              data-name="Icon map-wheelchair"
              d="M7.3,3.489A1.385,1.385,0,1,0,5.92,2.1,1.386,1.386,0,0,0,7.3,3.489Zm.978,12.7a4.3,4.3,0,0,1-4.27-4.34,4.353,4.353,0,0,1,1.5-3.285L5.433,7.2A5.493,5.493,0,0,0,8.282,17.335a5.674,5.674,0,0,0,4.982-3.462l-.822-1.133a4.277,4.277,0,0,1-4.16,3.443Zm8.444-2.657h-.692L13.265,9.72c-.15-.263-.692-1.038-1.385-1.038H8.765V7.3h2.769c.359,0,.746-.153.746-.521s-.377-.517-.746-.517H8.765V4.874c-.051-.768-.692-1.038-1.381-1.023s-1.042.33-1.042,1.023V9.72c.066.777.625,1.038,1.385,1.038H11.88L14.3,13.874c.156.258.692,1.038.692,1.038h1.731a.692.692,0,1,0,0-1.385Z"
              transform="translate(365.188 182.141)"
            />
          </g>
        </svg>
      );
      break;

    case 'instagram':
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 26.4 26.4">
          <g id="Group_53" data-name="Group 53" transform="translate(-61.6 -222)">
            <g id="_006-instagram" fill={secondaryColor} data-name="006-instagram" transform="translate(61.6 222)">
              <path
                id="Path"
                d="M5.053,2.527A2.527,2.527,0,1,1,2.527,0,2.527,2.527,0,0,1,5.053,2.527Z"
                transform="translate(10.673 10.673)"
              />
              <path
                id="Shape"
                d="M3.151,12.384a4.217,4.217,0,0,1-1.408-.261,2.345,2.345,0,0,1-.871-.567,2.348,2.348,0,0,1-.567-.872A4.205,4.205,0,0,1,.044,9.277C.008,8.478,0,8.238,0,6.214S.008,3.95.044,3.151A4.217,4.217,0,0,1,.305,1.743,2.356,2.356,0,0,1,.872.872,2.348,2.348,0,0,1,1.744.305,4.205,4.205,0,0,1,3.151.044C3.95.008,4.19,0,6.214,0S8.478.008,9.277.044a4.205,4.205,0,0,1,1.407.261,2.348,2.348,0,0,1,.872.567,2.352,2.352,0,0,1,.567.871,4.217,4.217,0,0,1,.261,1.408c.036.8.044,1.039.044,3.064s-.008,2.264-.044,3.063a4.205,4.205,0,0,1-.261,1.407,2.513,2.513,0,0,1-1.439,1.439,4.205,4.205,0,0,1-1.407.261c-.8.036-1.04.044-3.064.044S3.95,12.42,3.151,12.384Z"
                transform="translate(6.986 6.986)"
              />
              <path id="Shape-2" data-name="Shape" d="M0,13.2A13.2,13.2,0,1,1,13.2,26.4,13.2,13.2,0,0,1,0,13.2Z" />
            </g>
            <path
              id="Icon_awesome-instagram"
              data-name="Icon awesome-instagram"
              d="M7.01,5.654a3.6,3.6,0,1,0,3.6,3.6A3.59,3.59,0,0,0,7.01,5.654Zm0,5.933A2.338,2.338,0,1,1,9.348,9.25,2.342,2.342,0,0,1,7.01,11.587Zm4.581-6.08a.839.839,0,1,1-.839-.839A.837.837,0,0,1,11.591,5.507Zm2.381.851A4.15,4.15,0,0,0,12.84,3.42,4.178,4.178,0,0,0,9.9,2.287c-1.158-.066-4.628-.066-5.786,0a4.172,4.172,0,0,0-2.938,1.13A4.164,4.164,0,0,0,.044,6.355c-.066,1.158-.066,4.628,0,5.786A4.15,4.15,0,0,0,1.177,15.08a4.183,4.183,0,0,0,2.938,1.133c1.158.066,4.628.066,5.786,0A4.15,4.15,0,0,0,12.84,15.08a4.178,4.178,0,0,0,1.133-2.938c.066-1.158.066-4.625,0-5.783Zm-1.5,7.025a2.367,2.367,0,0,1-1.333,1.333A15.456,15.456,0,0,1,7.01,15a15.576,15.576,0,0,1-4.134-.282,2.367,2.367,0,0,1-1.333-1.333A15.456,15.456,0,0,1,1.261,9.25a15.576,15.576,0,0,1,.282-4.134A2.367,2.367,0,0,1,2.876,3.783,15.456,15.456,0,0,1,7.01,3.5a15.576,15.576,0,0,1,4.134.282,2.367,2.367,0,0,1,1.333,1.333,15.456,15.456,0,0,1,.282,4.134A15.447,15.447,0,0,1,12.477,13.384Z"
              transform="translate(67.791 225.922)"
              fill={color}
            />
          </g>
        </svg>
      );
      break;

    case 'tikTok':
      icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 26 26">
          <g id="Group_54" data-name="Group 54" transform="translate(-107 -222)">
            <circle
              id="Ellipse_1"
              data-name="Ellipse 1"
              cx="13"
              cy="13"
              r="13"
              fill={secondaryColor}
              transform="translate(107 222)"
            />
            <path
              id="Icon_simple-tiktok"
              data-name="Icon simple-tiktok"
              d="M8.912.012C9.695,0,10.471.006,11.248,0a3.722,3.722,0,0,0,1.046,2.492,4.214,4.214,0,0,0,2.533,1.07V5.969a6.4,6.4,0,0,1-2.51-.58,7.382,7.382,0,0,1-.968-.556c-.006,1.745.006,3.489-.012,5.228a4.564,4.564,0,0,1-.807,2.354A4.452,4.452,0,0,1,7,14.334a4.357,4.357,0,0,1-2.438-.615,4.506,4.506,0,0,1-2.181-3.412c-.012-.3-.018-.6-.006-.89A4.5,4.5,0,0,1,7.591,5.425c.012.884-.024,1.769-.024,2.653A2.05,2.05,0,0,0,4.95,9.345a2.37,2.37,0,0,0-.084.962,2.034,2.034,0,0,0,2.091,1.715,2.007,2.007,0,0,0,1.655-.962,1.379,1.379,0,0,0,.245-.633c.06-1.07.036-2.133.042-3.2.006-2.408-.006-4.81.012-7.212Z"
              transform="translate(111.999 228.004)"
              fill={color}
            />
          </g>
        </svg>
      );
      break;

    case 'search':
      icon = (
        <svg {...svgProps} width="27.9" height="27.9" viewBox="0 0 27.9 27.9">
          <g id="search" transform="translate(0 0)">
            <path
              id="Shape"
              d="M26.667,27.9h0l-9.455-9.455a10.486,10.486,0,1,1,1.233-1.233L27.9,26.667,26.668,27.9ZM10.463,1.744a8.719,8.719,0,1,0,8.719,8.718A8.728,8.728,0,0,0,10.463,1.744Z"
              transform="translate(0 0)"
              fill={color}
            />
          </g>
        </svg>
      );
      break;

    case 'star':
      icon = (
        <svg {...svgProps} width="22" height="20" viewBox="0 0 22 20">
          <g id="Shape" fill="none" strokeMiterlimit="10">
            <path
              d="M4.823,12.844l-1.1,5.8a1.11,1.11,0,0,0,.123.728,1.256,1.256,0,0,0,1.651.491L11,17.139l5.5,2.728.55.116a1.2,1.2,0,0,0,.734-.232,1.135,1.135,0,0,0,.489-1.1l-1.1-5.8,4.465-4.063a1.23,1.23,0,0,0,.306-1.219,1.272,1.272,0,0,0-.979-.755l-6.116-.871L12.1.655a1.193,1.193,0,0,0-.568-.539A1.254,1.254,0,0,0,9.9.655L7.147,5.937l-6.116.871a1.272,1.272,0,0,0-.979.755A1.23,1.23,0,0,0,.358,8.781Z"
              stroke="none"
            />
            <path
              d="M 4.929630279541016 19.00000190734863 C 4.972387313842773 19 5.013142585754395 18.99053001403809 5.05142068862915 18.97152137756348 L 10.99999046325684 16.02341079711914 L 16.83493614196777 18.91520881652832 L 17.12889289855957 18.97720527648926 C 17.15344429016113 18.97105026245117 17.17617607116699 18.96074295043945 17.19481086730957 18.94698143005371 L 17.21916007995605 18.92956161499023 C 17.26714515686035 18.89629173278809 17.29324340820312 18.85097503662109 17.29037666320801 18.80682182312012 L 16.0905704498291 12.48100185394287 L 20.93924331665039 8.068704605102539 C 20.98184204101562 8.019016265869141 21.00271987915039 7.961081981658936 20.99965476989746 7.902894020080566 C 20.95988845825195 7.849810600280762 20.8924503326416 7.809906959533691 20.81546783447266 7.795891761779785 L 14.20367050170898 6.854661464691162 L 11.21020030975342 1.10966157913208 C 11.19246006011963 1.074901580810547 11.15897083282471 1.044861555099487 11.1156702041626 1.024981617927551 C 11.07960033416748 1.00840163230896 11.04100036621094 1.000001549720764 11.00093078613281 1.000001549720764 C 10.90812015533447 1.000001549720764 10.82325077056885 1.044101595878601 10.78974056243896 1.109741568565369 L 10.78592014312744 1.117151618003845 L 7.796310424804688 6.854661464691162 L 1.18419075012207 7.795938014984131 C 1.107380032539368 7.809937477111816 1.040071249008179 7.849807262420654 1.000343680381775 7.902853488922119 C 0.9972907900810242 7.961024761199951 1.018173933029175 8.018980979919434 1.060772657394409 8.068727493286133 L 5.90941047668457 12.48112201690674 L 4.706314086914062 18.82427978515625 C 4.702980041503906 18.84775733947754 4.707698345184326 18.87128639221191 4.720340251922607 18.89423179626465 C 4.760618209838867 18.96728706359863 4.854472637176514 18.99999809265137 4.929630279541016 19.00000190734863 M 4.929546356201172 20.00000190734863 C 4.488835334777832 19.9999885559082 4.063051700592041 19.77326583862305 3.844600439071655 19.37701225280762 C 3.721330404281616 19.15337181091309 3.678250551223755 18.89762115478516 3.721800565719604 18.64865112304688 L 4.822700500488281 12.84428119659424 L 0.3578704595565796 8.781161308288574 C 0.03851046413183212 8.453531265258789 -0.07749953866004944 7.991361618041992 0.05209046229720116 7.562301635742188 C 0.2168004661798477 7.165671348571777 0.5879104733467102 6.879481792449951 1.030650496482849 6.807711601257324 L 7.146840572357178 5.937031745910645 L 9.899090766906738 0.655051589012146 C 10.19363021850586 0.07811214774847031 10.92517757415771 -0.1630891263484955 11.53323078155518 0.1163315773010254 C 11.78095054626465 0.2300915718078613 11.98090076446533 0.4199615716934204 12.10089015960693 0.655051589012146 L 14.85314083099365 5.937031745910645 L 20.96932983398438 6.807711601257324 C 21.41207122802734 6.879591464996338 21.78318023681641 7.165671348571777 21.94789123535156 7.562301635742188 C 22.07748985290527 7.991361618041992 21.96158981323242 8.453531265258789 21.64211082458496 8.781161308288574 L 17.17728042602539 12.84417152404785 L 18.2781810760498 18.6485424041748 C 18.34257125854492 19.07382202148438 18.15443992614746 19.49800109863281 17.78884124755859 19.75142097473145 C 17.57941055297852 19.90607261657715 17.32038116455078 19.98806381225586 17.05495071411133 19.98361206054688 L 16.50450134277344 19.86752128601074 L 10.99999046325684 17.13948249816895 L 5.495480537414551 19.86752128601074 C 5.31445837020874 19.95740127563477 5.120615005493164 20.00000762939453 4.929546356201172 20.00000190734863 Z"
              stroke="none"
              fill={color}
            />
          </g>
        </svg>
      );
      break;

    default:
      break;
  }

  return (
    <i className={classNames(css.icon, className)} {...iconProps} onClick={onClick}>
      {icon}
    </i>
  );
};

Icon.defaultProps = {
  className: '',
  width: 38.945,
  height: 38.948,
  color: '#111',
  secondaryColor: '#000',
  onClick: () => null,
};

export default Icon;
